export const heroData = {
  title: "わが子にぴったりが見つかる",
  subtitle: "ママが選んだおすすめのアイテム情報サイト",
  backgroundImage:
    "https://readdy.ai/api/search-image?query=Warm%20cozy%20mother%20and%20baby%20playing%20with%20toys%20in%20bright%20sunlit%20room%2C%20soft%20pastel%20colors%2C%20gentle%20warm%20tones%2C%20lifestyle%20photography%2C%20wooden%20floor%2C%20white%20interior%2C%20editorial%20style%20photo%20with%20soft%20natural%20lighting%20and%20cream%20color%20palette&width=1600&height=600&seq=hero-bg&orientation=landscape",
};

export const ageCategories = [
  {
    id: "pregnant",
    label: "妊娠中",
    icon: "ri-hearts-line",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20illustration%20of%20pregnant%20woman%20silhouette%20with%20gentle%20warm%20colors%2C%20minimal%20design%2C%20cream%20background%2C%20cute%20and%20friendly%20style%20for%20maternity%20website&width=300&height=300&seq=age-pregnant&orientation=squarish",
    color: "bg-primary-100",
  },
  {
    id: "age0",
    label: "0歳",
    icon: "ri-user-smile-line",
    image:
      "https://readdy.ai/api/search-image?query=Cute%20sleeping%20newborn%20baby%20portrait%20with%20soft%20warm%20lighting%2C%20pastel%20cream%20and%20pink%20tones%2C%20gentle%20peaceful%20atmosphere%2C%20professional%20lifestyle%20photography%20for%20parenting%20website&width=300&height=300&seq=age-0&orientation=squarish",
    color: "bg-accent-100",
  },
  {
    id: "age1",
    label: "1歳",
    icon: "ri-emotion-happy-line",
    image:
      "https://readdy.ai/api/search-image?query=Happy%20one%20year%20old%20toddler%20smiling%20and%20playing%20with%20colorful%20soft%20toys%2C%20warm%20indoor%20lighting%2C%20pastel%20cream%20background%2C%20cute%20lifestyle%20photography%20for%20parenting%20site&width=300&height=300&seq=age-1&orientation=squarish",
    color: "bg-secondary-100",
  },
  {
    id: "age2",
    label: "2歳",
    icon: "ri-footprint-line",
    image:
      "https://readdy.ai/api/search-image?query=Adorable%20two%20year%20old%20child%20playing%20with%20building%20blocks%2C%20bright%20cheerful%20room%2C%20warm%20natural%20lighting%2C%20soft%20pastel%20tones%20with%20cream%20and%20peach%20colors%2C%20parenting%20lifestyle%20photo&width=300&height=300&seq=age-2&orientation=squarish",
    color: "bg-primary-100",
  },
  {
    id: "age3",
    label: "3歳",
    icon: "ri-bear-smile-line",
    image:
      "https://readdy.ai/api/search-image?query=Three%20year%20old%20preschool%20child%20drawing%20with%20crayons%2C%20colorful%20art%20supplies%20on%20table%2C%20warm%20sunlit%20room%2C%20soft%20pastel%20aesthetic%20with%20cream%20and%20coral%20tones%2C%20happy%20lifestyle%20photography&width=300&height=300&seq=age-3&orientation=squarish",
    color: "bg-accent-100",
  },
  {
    id: "age4-6",
    label: "4～6歳",
    icon: "ri-heart-line",
    image:
      "https://readdy.ai/api/search-image?query=Cheerful%20preschool%20children%20ages%20four%20to%20six%20playing%20outdoors%20with%20bubbles%2C%20warm%20golden%20hour%20lighting%2C%20soft%20pastel%20colors%20with%20cream%20and%20peach%20background%2C%20joyful%20lifestyle%20photography&width=300&height=300&seq=age-4-6&orientation=squarish",
    color: "bg-secondary-100",
  },
  {
    id: "elementary",
    label: "小学生",
    icon: "ri-book-open-line",
    image:
      "https://readdy.ai/api/search-image?query=Elementary%20school%20child%20reading%20a%20book%20at%20desk%20with%20school%20supplies%2C%20warm%20cozy%20room%20lighting%2C%20soft%20pastel%20cream%20and%20light%20blue%20tones%2C%20studious%20and%20happy%20lifestyle%20photography&width=300&height=300&seq=age-elementary&orientation=squarish",
    color: "bg-primary-100",
  },
];

export const toyCategories = [
  {
    id: "toys",
    label: "おもちゃ",
    icon: "ri-bear-smile-line",
    color: "bg-primary-50 text-primary-700",
  },
  {
    id: "food",
    label: "食事グッズ",
    icon: "ri-restaurant-line",
    color: "bg-accent-50 text-accent-700",
  },
  {
    id: "outing",
    label: "お出かけ",
    icon: "ri-car-line",
    color: "bg-secondary-50 text-secondary-700",
  },
  {
    id: "sleep",
    label: "寝かしつけ",
    icon: "ri-moon-line",
    color: "bg-primary-50 text-primary-700",
  },
  {
    id: "toilet",
    label: "トイレ",
    icon: "ri-home-smile-line",
    color: "bg-accent-50 text-accent-700",
  },
  {
    id: "gift",
    label: "プレゼント",
    icon: "ri-gift-line",
    color: "bg-secondary-50 text-secondary-700",
  },
  {
    id: "education",
    label: "知育",
    icon: "ri-book-read-line",
    color: "bg-primary-50 text-primary-700",
  },
];

export const rankingArticles = [
  {
    rank: 1,
    title: "買ってよかったおもちゃ20選",
    views: "12,249",
    image:
      "https://readdy.ai/api/search-image?query=Colorful%20children%20toys%20arranged%20neatly%20on%20wooden%20shelf%2C%20soft%20warm%20lighting%2C%20pastel%20cream%20background%2C%20clean%20product%20photography%20style%20for%20parenting%20blog&width=300&height=200&seq=rank-article-1&orientation=landscape",
  },
  {
    rank: 2,
    title: "0歳から選べる知育玩具まとめ",
    views: "8,765",
    image:
      "https://readdy.ai/api/search-image?query=Educational%20toys%20for%20babies%20and%20toddlers%20on%20soft%20white%20fabric%2C%20wooden%20blocks%20and%20soft%20balls%2C%20warm%20natural%20lighting%2C%20pastel%20cream%20tones%20for%20parenting%20website&width=300&height=200&seq=rank-article-2&orientation=landscape",
  },
  {
    rank: 3,
    title: "長く使えるベビーグッズ特集",
    views: "6,540",
    image:
      "https://readdy.ai/api/search-image?query=High%20quality%20baby%20products%20and%20essentials%20flat%20lay%20on%20cream%20linen%20background%2C%20bottles%20diapers%20and%20clothes%2C%20soft%20warm%20lighting%2C%20minimal%20aesthetic%20for%20parenting%20site&width=300&height=200&seq=rank-article-3&orientation=landscape",
  },
];

export const rankingProducts = [
  {
    rank: 1,
    name: "すべてがおままごとセット",
    price: "3,980円",
    image:
      "https://readdy.ai/api/search-image?query=Colorful%20wooden%20play%20kitchen%20and%20cooking%20toy%20set%20for%20children%2C%20pastel%20colors%20with%20warm%20lighting%2C%20cream%20background%2C%20cute%20product%20photography%20for%20parenting%20store&width=300&height=300&seq=rank-product-1&orientation=squarish",
  },
  {
    rank: 2,
    name: "長く使える！木の積み木",
    price: "2,480円",
    image:
      "https://readdy.ai/api/search-image?query=Natural%20wooden%20building%20blocks%20for%20children%20stacked%20creatively%2C%20warm%20lighting%20on%20light%20wood%20surface%2C%20pastel%20cream%20tones%2C%20high%20quality%20product%20photography%20for%20toy%20shop&width=300&height=300&seq=rank-product-2&orientation=squarish",
  },
  {
    rank: 3,
    name: "ベビーチェアおすすめ5選",
    price: "参考価格",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20baby%20high%20chair%20in%20minimal%20white%20and%20wood%20design%2C%20clean%20studio%20lighting%2C%20cream%20background%2C%20product%20photography%20for%20parenting%20equipment%20catalog&width=300&height=300&seq=rank-product-3&orientation=squarish",
  },
];

export const rankingCategories = [
  { rank: 1, name: "おもちゃ", count: 128 },
  { rank: 2, name: "お出かけグッズ", count: 96 },
  { rank: 3, name: "食事グッズ", count: 84 },
];

export const momReviews = [
  {
    id: 1,
    name: "ゆいママ",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20smiling%20young%20Japanese%20mother%20with%20warm%20friendly%20expression%2C%20soft%20natural%20lighting%2C%20pastel%20cream%20background%2C%20lifestyle%20headshot%20for%20parenting%20community&width=100&height=100&seq=avatar-1&orientation=squarish",
    comment: "買ってよかった！これのおかげで家事が楽に",
    rating: 5,
  },
  {
    id: 2,
    name: "たろうママ",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20happy%20young%20mother%20with%20short%20hair%2C%20warm%20smile%2C%20soft%20natural%20lighting%20on%20cream%20background%2C%20lifestyle%20headshot%20for%20parenting%20review%20site&width=100&height=100&seq=avatar-2&orientation=squarish",
    comment: "失敗した…うちの子には合わなかったかも",
    rating: 2,
  },
  {
    id: 3,
    name: "みくママ",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20cheerful%20young%20mother%20with%20gentle%20smile%2C%20soft%20lighting%20on%20pastel%20background%2C%20warm%20and%20friendly%20lifestyle%20headshot%20for%20parenting%20blog&width=100&height=100&seq=avatar-3&orientation=squarish",
    comment: "買ってよかった！3歳まで毎日使ってます",
    rating: 5,
  },
];

export const articles = [
  {
    id: 1,
    title: "買ってよかったおもちゃ20選【2024年版】",
    views: "12,249 view",
    image:
      "https://readdy.ai/api/search-image?query=Collection%20of%20colorful%20popular%20children%20toys%20arranged%20on%20soft%20cream%20rug%2C%20warm%20indoor%20lighting%2C%20pastel%20tones%2C%20lifestyle%20photography%20for%20parenting%20article%20thumbnail&width=400&height=280&seq=article-1&orientation=landscape",
  },
  {
    id: 2,
    title: "0歳から長く使える！成長型おもちゃまとめ",
    views: "8,765 view",
    image:
      "https://readdy.ai/api/search-image?query=Baby%20playing%20with%20colorful%20developmental%20toys%20on%20soft%20play%20mat%2C%20warm%20cozy%20nursery%20room%2C%20pastel%20cream%20and%20pink%20tones%2C%20lifestyle%20photography%20for%20parenting%20blog&width=400&height=280&seq=article-2&orientation=landscape",
  },
  {
    id: 3,
    title: "実際に使ってよかった！離乳食グッズBEST10",
    views: "7,854 view",
    image:
      "https://readdy.ai/api/search-image?query=Baby%20food%20preparation%20items%20and%20cute%20feeding%20set%20on%20white%20table%2C%20colorful%20silicone%20plates%20and%20spoons%2C%20warm%20kitchen%20lighting%2C%20pastel%20cream%20tones%20for%20parenting%20site&width=400&height=280&seq=article-3&orientation=landscape",
  },
  {
    id: 4,
    title: "子連れお出かけに便利なアイテム15選",
    views: "6,540 view",
    image:
      "https://readdy.ai/api/search-image?query=Mother%20with%20toddler%20walking%20in%20park%20with%20stroller%20and%20baby%20bag%2C%20warm%20sunny%20day%2C%20soft%20pastel%20colors%20with%20cream%20and%20green%20tones%2C%20lifestyle%20photography%20for%20parenting%20blog&width=400&height=280&seq=article-4&orientation=landscape",
  },
  {
    id: 5,
    title: "寝かしつけがラクになる神アイテムまとめ",
    views: "5,432 view",
    image:
      "https://readdy.ai/api/search-image?query=Peaceful%20baby%20sleeping%20in%20cozy%20crib%20with%20soft%20night%20light%20and%20sleep%20aids%2C%20warm%20calming%20atmosphere%2C%20pastel%20cream%20and%20light%20blue%20tones%2C%20lifestyle%20photography%20for%20parenting%20site&width=400&height=280&seq=article-5&orientation=landscape",
  },
];

export const editorialPicks = [
  {
    id: 1,
    title: "夏のおでかけ特集",
    subtitle: "暑い日も快適に！必須持ち物チェック",
    image:
      "https://readdy.ai/api/search-image?query=Summer%20family%20outing%20essentials%20flat%20lay%20on%20beach%20towel%2C%20sunscreen%20hats%20water%20bottles%20and%20sand%20toys%2C%20warm%20bright%20lighting%2C%20pastel%20cream%20and%20blue%20tones%20for%20summer%20special%20feature&width=400&height=280&seq=feature-1&orientation=landscape",
    color: "bg-primary-50",
  },
  {
    id: 2,
    title: "プール・水遊び特集",
    subtitle: "子どもが喜ぶ！安心アイテムまとめ",
    image:
      "https://readdy.ai/api/search-image?query=Colorful%20swimming%20gear%20and%20water%20play%20toys%20for%20kids%20on%20poolside%2C%20floats%20goggles%20and%20water%20wings%2C%20bright%20summer%20lighting%2C%20pastel%20cream%20and%20blue%20tones%20for%20parenting%20feature&width=400&height=280&seq=feature-2&orientation=landscape",
    color: "bg-secondary-50",
  },
  {
    id: 3,
    title: "入園・入学準備特集",
    subtitle: "これで安心！必要なものリスト",
    image:
      "https://readdy.ai/api/search-image?query=School%20supplies%20and%20kindergarten%20preparation%20items%20neatly%20arranged%2C%20backpack%20lunchbox%20pencils%20and%20name%20tags%2C%20warm%20lighting%20on%20cream%20background%2C%20pastel%20tones%20for%20parenting%20special&width=400&height=280&seq=feature-3&orientation=landscape",
    color: "bg-accent-50",
  },
  {
    id: 4,
    title: "クリスマス特集",
    subtitle: "プレゼントに迷ったらこれを見て！",
    image:
      "https://readdy.ai/api/search-image?query=Festive%20Christmas%20gift%20wrapping%20scene%20with%20colorful%20presents%20and%20toys%20under%20tree%2C%20warm%20golden%20lighting%2C%20pastel%20cream%20and%20red%20green%20tones%2C%20cozy%20holiday%20photography%20for%20parenting%20site&width=400&height=280&seq=feature-4&orientation=landscape",
    color: "bg-primary-50",
  },
];

export const giftDiagnosisSteps = [
  { id: 1, label: "年齢は？", icon: "ri-cake-2-line" },
  { id: 2, label: "予算は？", icon: "ri-money-cny-circle-line" },
  { id: 3, label: "性別は？", icon: "ri-user-line" },
  { id: 4, label: "おすすめ表示", icon: "ri-gift-line" },
];

export const socialImages = {
  line: "https://readdy.ai/api/search-image?query=Smartphone%20displaying%20LINE%20app%20chat%20interface%20with%20cute%20stickers%20and%20family%20photos%2C%20warm%20lighting%2C%20pastel%20cream%20background%2C%20clean%20product%20mockup%20for%20social%20media%20promotion&width=500&height=350&seq=social-line&orientation=landscape",
  instagram: "https://readdy.ai/api/search-image?query=Smartphone%20showing%20Instagram%20app%20with%20photo%20grid%20of%20cute%20baby%20and%20parenting%20content%2C%20warm%20lighting%2C%20pastel%20cream%20background%2C%20clean%20product%20mockup%20for%20social%20media%20promotion&width=500&height=350&seq=social-instagram&orientation=landscape",
};

export const footerLinks = {
  byAge: [
    { label: "妊娠中", href: "#" },
    { label: "0歳", href: "#" },
    { label: "1歳", href: "#" },
    { label: "2～3歳", href: "#" },
    { label: "4～6歳", href: "#" },
    { label: "小学生", href: "#" },
  ],
  byCategory: [
    { label: "おもちゃ", href: "#" },
    { label: "プレゼント", href: "#" },
    { label: "食事グッズ", href: "#" },
    { label: "知育", href: "#" },
    { label: "お出かけ", href: "#" },
    { label: "寝かしつけ", href: "#" },
  ],
  features: [
    { label: "特集一覧", href: "#" },
    { label: "ランキング", href: "#" },
    { label: "プレゼント診断", href: "#" },
    { label: "入園・入学特集", href: "#" },
    { label: "クリスマス特集", href: "#" },
  ],
  about: [
    { label: "ランキング", href: "#" },
    { label: "プレゼント診断", href: "#" },
    { label: "口コミ", href: "#" },
    { label: "よくある質問", href: "#" },
    { label: "お問い合わせ", href: "#" },
  ],
};